// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"466":"ba36b58e","863":"00da3281"}[chunkId] + ".chunk.css";
};